import { loader } from "@folio-2026/content"
import Experience from "@folio-2026/experience"
import { AnimatedText, EVENTS, Grid, SmallButton } from "@folio-2026/shared"
import { useGSAP } from "@gsap/react"
import { gsap, ScrollTrigger } from "gsap/all"
import { useRef } from "react"

gsap.registerPlugin(ScrollTrigger)

export default function IntroContent() {
  const triggerRef = useRef<HTMLDivElement | null>(null)
  const experience = useRef(Experience.getInstance())

  useGSAP(() => {
    /**
     * Section leave animation
     */

    ScrollTrigger.create({
      trigger: triggerRef.current,
      start: "bottom bottom",
      end: "bottom top",
      markers: false,
      scrub: true,
      onLeave() {
        experience.current.trigger(EVENTS.Loader.Exited)
      },
      onUpdate({ progress, direction }) {
        experience.current.trigger(EVENTS.Loader.Exiting, [
          {
            progress,
            direction,
          },
        ])
      },
    })
  })

  return (
    <div ref={triggerRef} className="relative min-h-screen">
      <div className="fixed inset-0 flex flex-col justify-end items-stretch pointer-events-none">
        <Grid>
          <div className="col-start-1 ml-4 mb-1 md:ml-0 md:col-start-3 lg:col-start-7 lg:col-span-4 col-span-3 md:col-span-4 max-w-sm text-gray-500">
            <AnimatedText
              preventUpdate
              data-font-bold
              tag="h1"
              className="text-gray-700"
              content="["
            />
            <AnimatedText
              preventUpdate
              data-font-bold
              tag="h1"
              className="text-gray-700 mt-1"
              content="    [[ABOUT]"
              highlight={{ substring: "ABOUT", className: "text-gray-500" }}
            />
            <AnimatedText
              preventUpdate
              data-font-bold
              tag="h1"
              className="text-gray-700 mt-1"
              content="        []]]"
            />
            <AnimatedText
              preventUpdate
              data-font-bold
              tag="h1"
              className="text-gray-700 mt-1"
              content="               [[[]"
            />
          </div>
          <div className="col-start-2 ml-4 md:ml-0 md:col-start-4 lg:col-start-8 lg:col-span-4 col-span-3 md:col-span-4 lg:max-w-md text-gray-500">
            <AnimatedText
              preventUpdate
              data-font-bold
              className="text-gray-500"
              content={loader.description}
            />
          </div>
          <div className="col-start-1 ml-4 md:ml-0 md:col-start-3 lg:col-start-7 lg:col-span-4 col-span-3 md:col-span-4 max-w-sm text-gray-500">
            <AnimatedText
              preventUpdate
              data-font-bold
              tag="h1"
              className="text-gray-700"
              content="   ]]]"
            />
          </div>
          <div className="col-start-2 ml-4 mb-15 md:mb-10 md:ml-0 md:col-start-4 lg:col-start-8 lg:col-span-4 col-span-3 md:col-span-4 lg:max-w-md text-gray-500">
            <SmallButton
              preventUpdate
              id="about-cta"
              className=""
              clickEvent={EVENTS.About.EnterCTA.Click}
              hoverEvent={EVENTS.About.EnterCTA.Hover}
              outEvent={EVENTS.About.EnterCTA.Out}
            >
              ABOUT
            </SmallButton>
          </div>
        </Grid>
      </div>
    </div>
  )
}
